// CALL AXIOS TO CONSUME WEB SERVICE
import axios from "axios"
import authHeader from "../authentification/AuthHeader";

//GET URL FROM .ENV ELEMENT
import { getUrl } from "../authentification/DotenvConfig"

/**
 * URL OF APP 
 * EXAMPLE : https://exemple/api/v1
 */
const url = getUrl()


/**
 * ADD DATA OF SINISTRE 
 * @param {*} data 
 * @returns 
 */
export async function addSinistre(data) {
    try {
        const response = await axios.post(url + "sinistres", data, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}

/**
 * ADD MEDIA SINISTRE
 * @param {*} data 
 * @returns 
 */
export async function addMediaSinistre(data) {
    try {
        const formData = new FormData();
        formData.append("sinistre_id",data.sinistre_id)
        for (const key of Object.keys(data.file)) {
            formData.append('file',data.file[key])
        }
        const response = await axios.post(url + "sinistre-medias", formData, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}
/**
 * GET LISTE OF CLAIM DECLARATIONS by USER ID
 * @param {*} id  // USER ID
 * @returns 
 */
export async function getSinistreUser(id) {
    try {
        const response = await axios.get(url + "sinistres/users/"+id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}

export async function getSinistreById(id) {
    try {
        const response = await axios.get(url + "sinistres/"+id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}
/**
 * GET FILES OF CLAIM DECLARATIONS by sinistre_id
 * @param {*} id // id sinistre
 * @returns 
 */
export async function getSinistreMediaUser(id) {
    try {
        const response = await axios.get(url + "sinistre-medias/sinistres/"+id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}

/**
 * Supprimer un objet sinistre BY ID MEDIA SINISTRE
 * @param {*} id 
 * @returns 
 */
export async function deleteMediaSinistre(id) {
    try {
     
        const response = await axios.delete(url + "sinistre-medias/"+id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}

/**
 * DELETE ALL MEDIA OF ID SINISTE
 * @param {*} id 
 * @returns 
 */
export async function deleteAllMediaSinistre(id) {
    try {
     
        const response = await axios.delete(url + "sinistre-medias/sinistres/"+id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}